<template>
  <q-section v-bind="$attrs">
    <q-section v-bind="innnerStyles" :key="`inner-progress-${innnerStyles?.w}-${innnerStyles?.h}-${fakeLenth}`" class="of-h">
      <q-section :bg-i="props.innerBg"></q-section>
    </q-section>
  </q-section>
</template>

<script setup lang="ts">
import { toRef } from 'vue'
import { useProgress } from '../composable/use-progress'

const props = defineProps({
  total: {
    type: Number,
    default: 0,
  },
  current: {
    type: Number,
    default: 0,
  },
  direction: {
    type: String,
    default: 'vertical',
  },
  innerBg: {
    type: String,
    default: '',
  },
  fakeLenth: {
    type: Number,
    default: 0,
  },
})

const { innnerStyles } = useProgress({
  current: toRef(props, 'current'),
  total: toRef(props, 'total'),
  direction: props.direction as 'horizontal' | 'vertical',
  fakeLenth: props.fakeLenth as number | string,
})
</script>

<style scoped lang="scss">
.of-h {
  overflow: hidden;
}
</style>
